import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.cuvetteRack[ownProps.id-1].type
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
